module.exports = require('../manifest.json').version



//////////////////
// WEBPACK FOOTER
// ./~/youboralib/src/version.js
// module id = 8
// module chunks = 0